<template>
  <v-layout v-if="show" class="text-xs-center font-weight-light subheading blue-grey--text my-5">
    <v-fade-transition mode="out-in">
      <v-flex
        v-if="!loading && !features.length"
        key="no-features"
      >No hay atributos creados para esta clasificación.</v-flex>
      <v-flex v-else key="loading">
        <v-pulse-loader :loading="loading" />
      </v-flex>
    </v-fade-transition>
  </v-layout>
</template>

<script>
import { mapState } from "vuex";
import VPulseLoader from "vue-spinner/src/PulseLoader";

export default {
  components: {
    VPulseLoader
  },
  computed: {
    ...mapState("ner", {
      features: state => state.features,
      loading: state => state.loadingFeatures
    }),
    /**
     * Show the messages if the features are loading or there are no features to show.
     */
    show() {
      return this.loading || !this.features.length;
    }
  }
};
</script>
